import api from '@/api'

import type { Brand } from '@/types/brand'

class BrandService {
  getBrands = async (bpId: number | null, filters: Record<string, unknown>): Promise<{ brands: Brand[], totalFilteredCount: number }> => {
    const response = await api.get<{
      data: Array<{
        id: number
        name: string
        attributes?: { Colors?: string[] }
        assets?: { Logo?: string[] }
        createdAt: string
      }>
      totalFilteredBrands: number
    }>(`businessProfiles/${bpId}/brands/search`, filters)

    const brands = response.data.map((brand) => ({
      id: brand.id,
      name: brand.name,
      colours: brand.attributes?.Colors ?? [],
      logoUrls: (brand.assets?.Logo ?? []).map((logo: string) => ({
        logoUrl: logo,
        loading: false,
      })),
      createdAt: brand.createdAt,
    }))

    return {
      brands,
      totalFilteredCount: response.totalFilteredBrands,
    }
  }
}

export default BrandService
